import {
  CheckCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';

import {
  Button, Card,
} from 'antd';
import React, { Fragment } from 'react';

const { Meta } = Card;

const GlobalLabelsCard = ({
  labelsData, loading, setShowFormDrawer, setSelectedGlobalLabel, viewOnly = false,
}) => (
  <Fragment>
    <Card
      style={{
        width: 360,
        boxSizing: 'border-box',
        borderRadius: '3px',
      }}
      loading={loading}
      cover={(
        <div
          dangerouslySetInnerHTML={{ __html: labelsData?.preview_html }}
          style={{
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: '360px',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px',
            height: '100%',
            maxHeight: '360px',
            overflowY: 'auto',
            scrollbarWidth: '1px !Important',
          }}
        />
      )}
      actions={viewOnly ? [] : [
        !labelsData?.isAdded ? (
          <Button
            loading={loading}
            type="primary"
            icon={<PlusCircleOutlined />}
            key={`${labelsData?.global_label_id}_add_button`}
            onClick={() => {
              setShowFormDrawer(true);
              setSelectedGlobalLabel(labelsData);
            }}
          >
            Add
          </Button>
        ) : (
          <Button disabled type="primary" icon={<CheckCircleOutlined />} key={`${labelsData?.global_label_id}_added_button`}>
            Added
          </Button>
        ),
      ]}
      bodyStyle={{ padding: viewOnly ? '0px' : '24px' }}
    >
      {viewOnly ? '' : (
        <Meta
        // avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />}
          title={labelsData?.label_name}
        />
      )}
    </Card>

  </Fragment>
);

export default GlobalLabelsCard;
